module.exports = __webpack_public_path__ + "static/media/ecarts.5e2667ed.jpg";